
import { useState } from 'react';
import Hero from './components/Hero';
import CompanyOverview from './components/CompanyOverview';
import Services from './components/Services';
import DentalCare from './components/DentalCare';
import WhyGlorib from './components/WhyGlorib';
import Partnerships from './components/Partnerships';
import CTA from './components/CTA';
import Footer from './components/Footer';
import Navbar from './components/Navbar';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <Hero />
      <CompanyOverview />
      <Services />
      <DentalCare />
      <WhyGlorib />
      <Partnerships />
      <CTA />
      <Footer />
    </div>
  );
}
